export enum CorporateAudience {
  General = 'general',
  Employee = 'employee',
}
